<template>
  <div class="home-nav" :class="theme">
    <el-header>
      <div class="nav-box nav-box-logo">
        <img
            :src="theme === 'dark' ? require('@/assets/logo-mini-dark.png') : require('@/assets/logo-mini-white.png')"
            alt="smart-civil-logo" class="nav-logo" @click="$router.push({name: 'home'})"></div>
      <div class="nav-box nav-box-menu" v-show="!noMenu || quickMenu.length">
        <ul class="menu-list" v-if="!noMenu">
          <li class="menu-item">概况</li>
          <li class="menu-item" @click="$router.push('intellect-computed')">智能计算</li>
          <li class="menu-item" @click="$router.push('intellect-design')">智能设计</li>
          <li class="menu-item" @click="$router.push('intellect-eqdiscivil')">公式智能发现</li>
<!--          <li class="menu-item" @click="$router.push('person-space')">个人空间</li>-->
          <li class="menu-item" @click="openAboutUs">联系我们</li>
        </ul>
        <el-menu
            :default-active="activeRouter"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            v-else-if="quickMenu && quickMenu.length"
        >
          <el-menu-item
              v-for="item in quickMenu"
              :key="item"
              :index="item"
          >{{ item | routeNameFilter }}</el-menu-item>
        </el-menu>
      </div>
      <div class="nav-box nav-box-login">
        <div class="user-info" v-if="$store.state.login.userInfo.username">
          <div class="user-btn" style="display: inline-block;cursor: pointer"  @click="$router.push('person-space')">
            <el-avatar
                size="small"
                :src="$store.state.login.userInfo.avatar || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'">
              >
            </el-avatar>
          </div>

          {{ $store.state.login.userInfo.username }} &nbsp;
          <i class="el-icon-switch-button" @click="logout"></i>
        </div>
        <template v-else>
          <div class="login-btn" @click="showLoginDialog">
            登陆
          </div>
          /
          <div class="login-btn" @click="showRegisterDialog">
            注册
          </div>
        </template>
      </div>
      <div class="nav-box nav-box-back" v-show="noMenu">
        <el-button icon="el-icon-arrow-left" :type="theme === 'dark' ? 'primary' : ''" :plain="true"
                   @click="$router.go(-1)">返回
        </el-button>
      </div>
    </el-header>
    <el-dialog
        title="联系我们"
        width="35%"
        :visible.sync="dialogVisible"
        :modal-append-to-body="false"
    >
      <div class="about-us">
        有任何意见或建议，欢迎通过QQ群或微信公众号联系我们： <br>
        <img class="qr" :src="require('@/assets/qq-qun.png')">
        <br>
        <img class="qr-gzh" :src="require('@/assets/gzh.png')">
        <br>
        本团队公众号
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {logoutApi} from "../api/login";
import {delCookie} from "../util/cookie";
import store from "../store/store";

export default {
  name: "header-nav",
  data() {
    return {
      activeRouter: '',
      dialogVisible: false
    }
  },
  props: {
    noMenu: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'white'
    },
    quickMenu: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    routeNameFilter(val) {
      switch (val) {
        case 'intellect-computed':
          return '钢板剪力墙';
        case 'custom-structure':
          return '自定义结构';
        case 'edit-custom-structure':
          return '编辑自定义结构';
      }
    }
  },
  methods: {
    handleSelect(index) {
      this.$router.push(index);
    },
    showLoginDialog() {
      this.$store.dispatch('login/showLoginDialog')
    },
    showRegisterDialog() {
      this.$store.dispatch('login/showRegisterDialog')
    },
    async logout() {
      try {
        await this.$confirm('您确定要退出登陆么？', '温馨提示', {
          type: 'warning'
        });
        logoutApi().finally(() => {
          delCookie('g_session');
          this.$router.push({name: 'home'})
          this.$store.dispatch('login/clearUserInfo');
          localStorage.setItem('userinfo', null);
        });
      } catch (e) {
      }
      ;
    },
    openAboutUs() {
      this.dialogVisible = true;
    }
  },
  watch: {
    '$route.name': {
      handler(val){
        this.activeRouter = this.$route.name
      }
    }
  }
};
</script>

<style lang="less" scoped>

.home-nav {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background-color: transparent;
  width: 100%;
  color: white;
  min-width: 1152px;
  text-align: left;
  height: 60px;

  .el-header {
    margin: 0 auto;
    position: relative;
  }

  .nav-box {
    height: 60px;
    display: inline-block;
    vertical-align: middle;
    line-height: 60px;

    .nav-logo {
      margin-top: 13px;
      margin-left: 4px;
      height: 30px;
      cursor: pointer;
    }

  }

  .nav-box-logo {
    float: left;
  }

  .nav-box-login {
    position: relative;
    height: 60px;
    float: right;
    line-height: 60px;
    color: #fff;

    .user-info {
      .el-avatar {
        vertical-align: middle;
      }

      .el-icon-switch-button {
        cursor: pointer;

        &:hover {
          color: #ffbb00;

        }
      }
    }

    .login-btn {
      cursor: pointer;
      display: inline-block;
      margin: 0 3px;
      font-size: 16px;

      &:hover {
        color: #ffbb00;
      }
    }
  }

  .menu-list {
    margin: 0 0 0 50px; /* 删除默认的外边距 */
    list-style: none; /* 删除默认的列表符号 */
    padding: 0; /* 删除默认的内边距 */
    text-align: left;

    .menu-item {
      display: inline-block;
      max-width: 200px;
      min-width: 150px;
      text-align: center;
      color: aliceblue;
      cursor: pointer;

      &:hover {
        color: #ffbb00;
      }
    }
  }
}

.nav-box-back {
  float: right;
  margin-right: 15px;


}

.dark .el-button--primary {
  background-color: #111111;
  border: 1px solid #111111;
  color: #fff;
}

.white {
  .home-nav {
    background-color: #ffffff;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);

    .nav-box {
      color: #000;
    }

    .nav-box-back {
      float: right;
      margin-right: 15px;
    }
  }
}

.about-us {
  text-align: center;

  .qr {
    width: 30%;
  }

  .qr-gzh {
    width: 40%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/header-nav.vue